import { render, staticRenderFns } from "./qualityItemManager.vue?vue&type=template&id=a0064f5a&"
import script from "./qualityItemManager.vue?vue&type=script&lang=js&"
export * from "./qualityItemManager.vue?vue&type=script&lang=js&"
import style0 from "./qualityItemManager.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports